module.exports = __webpack_public_path__ + "static/cta-banner-263a7ded6902633cbb70c38df257b301.jpg";